/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useState } from 'react'
import QRCode from 'react-qr-code'
import CrudList from '@/components/CrudList'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

// ADR-0012-adenda F3: etiqueta escaneável (QR do Device.code) na tela de Coletores. O gestor
// abre o QR grande e o operador pica-o no login-por-scan (F4). Mesma lib/contraste do catálogo
// (react-qr-code): preto-sobre-branco REAL numa caixa branca fixa (lê-se com scanner mesmo em
// dark mode). Só toca o Devices.tsx (coluna + modal); não mexe no CrudList.
export default function Devices() {
  const [qrCode, setQrCode] = useState<string | null>(null)

  return (
    <>
      <CrudList
        title="Coletores"
        endpoint="/api/workforce/devices/"
        writable
        canDelete={false}
        columns={[
          { key: 'code', header: 'Código' },
          { key: 'name', header: 'Nome' },
          { key: 'device_type', header: 'Tipo' },
          {
            key: 'brand',
            header: 'Marca / modelo',
            render: (r: any) =>
              [r.brand, r.model].filter(Boolean).join(' ') || '—',
          },
          {
            key: 'serial_no',
            header: 'Série',
            render: (r: any) => r.serial_no || '—',
          },
          {
            key: 'is_active',
            header: 'Estado',
            render: (r: any) => (r.is_active ? 'Ativo' : 'Inativo'),
          },
          {
            key: '_qr',
            header: 'Etiqueta',
            render: (r: any) =>
              r.code ? (
                <button
                  className="text-blue-600 hover:underline"
                  onClick={() => setQrCode(r.code)}
                >
                  Ver QR
                </button>
              ) : (
                '—'
              ),
          },
        ]}
      />

      <Dialog open={!!qrCode} onOpenChange={(o) => !o && setQrCode(null)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Etiqueta do coletor — {qrCode}</DialogTitle>
          </DialogHeader>
          {qrCode && (
            <div className="flex flex-col items-center gap-3 py-2">
              {/* caixa branca fixa: preto-sobre-branco REAL (scanner lê o contraste, mesmo dark). */}
              <div className="bg-white p-4 rounded">
                <QRCode
                  value={qrCode}
                  size={220}
                  fgColor="#000000"
                  bgColor="#ffffff"
                />
              </div>
              <div className="text-sm opacity-80">{qrCode}</div>
              <button className="btn" onClick={() => setQrCode(null)}>
                Fechar
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
